import "../../scss/core.scss"

import "../oldCode/navigation"
import "../oldCode/stickyHeader"

import { debounce } from "oj-utils"

// (function () { // hide chat in footer if chat isn't loaded
//   var attempts = 0
//   function test() {
//     attempts++
//     if (attempts > 20) {
//       var a = document.querySelector(".footer-bar ul a") as HTMLAnchorElement
//       if (a.href.indexOf("javascript") === 0)
//         a.parentElement.style.display = "none"
//     }
//     if (!document.querySelector(".zopim"))
//       setTimeout(test, 500)
//   }
//   setTimeout(test, 500)
// })()


if (document.querySelector('.chooseFile') !== null)
  import("../oldCode/satisfaction-file")

if (window["serviceHub"] !== false)
  import("../service_hub").then(x => x.init())

if (document.querySelector('[data-m-video]'))
  import('./videoBlock/videoBlock')

if (document.querySelector('[data-global-message]'))
  import('../components/messages/globalMessage')

if (document.querySelector('[data-m-newsletter-form]'))
  import('../components/newsletter/newsletterForm')

import('./tracking')
import('./basketAmount')


// if (document.querySelector("[data-appstore-banner]")) {
//   import("../entries/appstoreBanner/appstoreBanner")
// }

if (document.querySelector('[data-back-to-top]')) {
  const elements = document.querySelectorAll('[data-back-to-top]');

  elements.forEach(x => {
    x.on("click", () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    })
  })
}


new ResizeObserver(debounce(100, () => {
  Array.from(document.querySelectorAll(".readmore")).forEach((x: HTMLElement) => {
    const h = x.querySelector(".richtext").scrollHeight;

    if (h < 200) {
      x.classList.remove("readmore");
    } else {
      const pct = Math.min(160 / h, 1);
      (x.querySelector(".readmore-container") as HTMLElement).style.setProperty("--fraction", `${pct}fr`);
      const btn = x.querySelector("button") as HTMLButtonElement;
      btn.on("click", () => {
        btn.classList.toggle("more")

        if (!btn.classList.contains("more"))
          x.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
      })
    }
  })
})).observe(document.body)

